import { types as t, Instance } from "mobx-state-tree"

export const FormModel = t.model({
  errors: t.map(t.maybe(t.string)),
  name: t.string,
})

export interface FormModelInterface extends Instance<typeof FormModel> {}
